import { DataClassName } from '@/Data/const'

export const getKanbanViewPresent: (dataClassName: string) => boolean = (
  dataClassName,
) => {
  switch (dataClassName) {
    case DataClassName.LEAD:
    case DataClassName.OPPORTUNITY:
      return true
    default:
      return false
  }
}
